import { AsyncEntity } from '@anm/helpers/redux/asyncEntity';
import pick from 'lodash/fp/pick';

const pickRequestFailure = (entity: AsyncEntity) =>
  pick<typeof entity, keyof typeof entity>(['request', 'failure'])(entity);

export default pickRequestFailure;
